import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button } from 'reactstrap'
import { FormattedHTMLMessage } from 'react-intl'
import { steamActions } from '../../redux/actions'
import FormattedMessage from '../../components/FormattedMessage/FormattedMessage'
import Loader from '../../components/Loader/Loader'

class SteamRedirect extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
    }
  }

  componentDidMount() {
    this.getData()
  }

  componentDidUpdate(prevProps) {
    const { location, integrationCheck, authUser } = this.props
    if (authUser !== prevProps.authUser) {
      const parsedLocation = this.handleLocation(location)
      if (parsedLocation) {
        integrationCheck(parsedLocation, authUser)
      }
    }
  }

  getData() {
    setTimeout(() => {
      this.setState({ loading: false })
    }, 1500)
  }

  handleLocation = location => {
    if (location.hash) {
      const params = location.hash.split('#')[1].split('&')
      const mergedHashKeys = params.reduce((acc, param) => {
        const [key, value] = param.split('=')
        if (key) {
          acc[key] = value
        }
        return acc
      }, {})
      return mergedHashKeys
    }
  }

  steamLoginMessage = ({ steamid, accessToken }) => {
    const { loading } = this.state

    if (loading) {
      return <Loader aria-live="polite" />
    }
    return (
      <p className="text-center" aria-live="polite">
        {steamid && accessToken ? (
          <FormattedMessage id="steam.label.extraInstruction" />
        ) : (
          <FormattedHTMLMessage id="error.steam.account" />
        )}
      </p>
    )
  }

  buttonClick = () => {
    window.close()
  }

  render() {
    const { steam } = this.props

    return (
      <div
        className="jumbotron jumbotron-fluid d-flex align-items-center justify-content-center bg-white"
        style={{ minHeight: '100vh' }}
        role="main"
        aria-label="Steam Authentication Result"
        tabIndex={-1}
      >
        <div className="container">
          <h1 className="page-title text-center" aria-level="1">
            <FormattedMessage id="steam.label.authenticated" />
          </h1>
          {this.steamLoginMessage(steam)}
          <h4 className="text-center" aria-level="2">
            <Button color="dark" block outline onClick={this.buttonClick} aria-label="Close window">
              <FormattedMessage id="global.label.windowClose" />
            </Button>
          </h4>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  steam: state.steamReducer,
})

const mapDispatchToProps = dispatch => ({
  integrationCheck: (...args) =>
    dispatch(steamActions.integrationCheck(...args))
      .then(() => dispatch(steamActions.saveParsedHash(...args)))
      .catch(() => dispatch(steamActions.removeAuthUser())),
})

export default connect(mapStateToProps, mapDispatchToProps)(SteamRedirect)
